/* lib/diag/carrilTripwire.js — EL TRIPWIRE DEL CARRIL (tanda CARRIL-DIAG).
 *
 * ── EL HECHO QUE ESTE ARCHIVO EXISTE PARA CAZAR ─────────────────────────────
 * Smoke del build #72 (2026-08-12, capturas de las 10:04 vs 10:06): tras un
 * gesto de deslizamiento CANCELADO A MEDIAS, la pantalla del pane Inicio quedó
 * CORRIDA a la izquierda —el contenido cortado en el borde izquierdo, la píldora
 * de navegación intacta—. Cambiar de pestaña NO lo arregló; sólo matar la app lo
 * restauró. No es reproducible a voluntad.
 *
 * El censo de esta tanda dejó cuatro capas capaces de producir exactamente esa
 * imagen, y NINGUNA de las cuatro se puede descartar desde jsdom, porque el
 * síntoma es una posición de scroll o un transform que sobrevive en un aparato
 * real. Este módulo es el instrumento que las separa cuando vuelva a pasar.
 *
 * ── LA LEY QUE VIGILA (H-1, EN REPOSO) ──────────────────────────────────────
 * Sin gesto en vuelo, el carril tiene que estar así y no de otra forma:
 *   · `pager-carril`, `pager-gesto` y `pager-riel` SIN transform. El único que
 *     transforma es el gesto, y sólo mientras el dedo está abajo o dura el
 *     asentamiento (`lib/useTabSwipe.js`).
 *   · el `left` del riel en un múltiplo EXACTO de −100% (lo escribe React:
 *     `components/PagerRaices.js:185`). Un valor fraccionario significa que algo
 *     que no es React le está escribiendo la posición de reposo.
 *   · `scrollLeft` en CERO en toda la cadena observable. Ésta es la sospechosa
 *     principal, y el porqué está en la geometría: el pane lleva
 *     `overflow-y-auto` y NADA en x, y por la regla de CSS Overflow 3 §3.2 —"si
 *     un eje no es `visible` y el otro sí, el `visible` computa a `auto`"— su
 *     `overflow-x` COMPUTA a `auto`. O sea que el pane, el `<main>` del chasis y
 *     el `pager-carril` (`overflow-hidden`, que sigue siendo un scrollport
 *     programable) pueden todos guardar un desplazamiento horizontal que nada
 *     en la app vuelve a poner en cero: cambiar de pestaña no lo toca —la
 *     posición de scroll de cada pane se CONSERVA por diseño
 *     (`components/PagerRaices.js:57-60`)— y por eso sólo matar la app lo cura.
 *
 * ── LAS TRES RESTRICCIONES, Y SON DURAS ─────────────────────────────────────
 *   1. CERO CAMBIOS A LOS ARCHIVOS DEL CARRIL Y DE GESTOS. Este módulo es un
 *      OBSERVADOR EXTERNO: localiza todo por DOM (`data-testid`), no importa ni
 *      un componente del carril y no lo modifica. Lo único que toma prestado de
 *      `useTabSwipe`/`useEdgeSwipeBack` son sus DOS constantes de tiempo, para
 *      no reinventar el reloj del asentamiento con números mágicos.
 *   2. OBSERVA, NO CURA. **Ya no: REMATE-266 la levantó, y a propósito.** Ver
 *      abajo — la restricción cumplió su función (aislar el instrumento del
 *      mecanismo mientras no se sabía qué pasaba) y el precio de mantenerla es
 *      que el único remedio del usuario siga siendo matar la app.
 *   3. COSTO EN REPOSO ≈ CERO. Sin listeners de movimiento y sin trabajo por
 *      frame. Los disparadores son (a) un `MutationObserver` sobre el atributo
 *      `style` del RIEL —que React sólo toca al cambiar de pestaña, y que el
 *      gesto JAMÁS toca (el gesto pinta el nodo del gesto, no el riel)—, (b)
 *      `scrollend` pasivo donde el navegador lo soporte, que es literalmente el
 *      instante en que un scroll rebelde aterriza, (c) `touchend`/`touchcancel`
 *      pasivos sobre el carril, con la revisión aplazada hasta después del
 *      asentamiento, y (d) un latido lento de respaldo.
 *
 * ── REMATE-266 — DE TRIPWIRE A AUTO-CURA ────────────────────────────────────
 * El síntoma que este archivo caza dura MINUTOS y sólo se quita matando la app,
 * porque nada en el producto vuelve a poner en cero un desplazamiento
 * horizontal: cambiar de pestaña no lo toca (la posición de scroll de cada pane
 * se CONSERVA por diseño). Detectarlo y callarse era correcto mientras no se
 * supiera qué lo produce; hoy la ley de reposo está escrita, verificada y con
 * rojos, así que la misma función que la juzga puede restaurarla. El episodio
 * pasa de "minutos hasta el kill" a un parpadeo.
 *
 * DOS CORRECCIONES, CERO CAMBIOS DE CSS:
 *   · EN EL ATERRIZAJE DE PESTAÑA (`components/PagerRaices.js`): el carril
 *     restaura el desplazamiento HORIZONTAL de sus capas a cero. Es el momento
 *     natural —el usuario acaba de cambiar de pantalla— y el más barato.
 *   · AL DETECTAR (`revisar`, abajo): además de escribir `NAV.H1`, se corrige el
 *     valor en el acto.
 *
 * EL SCROLL VERTICAL NO SE TOCA, y esto es load-bearing: que cada pane conserve
 * su posición vertical al cambiar de pestaña es una PROPIEDAD del carril, no un
 * accidente. Aquí sólo se escribe `scrollLeft`, jamás `scrollTop`, y jamás se
 * toca un contenedor de scroll ni una regla de CSS (arquitectura COS-33).
 *
 * EL TRANSFORM SE CURA, PERO NO DESDE EL LATIDO. Un transform en el carril es
 * ILEGÍTIMO en reposo y LEGÍTIMO mientras el dedo está abajo, y el latido lento
 * es el único disparador que puede caer en pleno gesto (los otros tres ocurren
 * en momentos de reposo por construcción, y el del dedo espera el peor
 * asentamiento posible antes de juzgar). Curarlo desde el latido significaría
 * arrancarle el carril al usuario a media pasada; por eso desde el latido se
 * REGISTRA y no se cura, y la corrección la aplica el siguiente disparador de
 * reposo — que llega con el dedo levantado.
 *
 * TANDA 18 (#207): y desde la T18 tampoco REGISTRA cuando cae sobre un estado
 * fresco. Registrar era la mitad correcta del razonamiento de arriba —el latido
 * cae con el dedo abajo— pero la línea decía "anomalía" de un carril sano, y el
 * anillo del visor son 500 entradas. Ver `veredictoDelGatillo`.
 *
 * ── CÓMO SE LEE LA LÍNEA ────────────────────────────────────────────────────
 * `NAV.H1` en el visor (`/diag/ready-chain`), con la autopsia:
 *   capa      qué nodo violó la ley ('pane:/dashboard', 'carril', 'main',
 *             'documento', 'riel', 'gesto', 'body').
 *   prop      'scrollLeft' | 'transform' | 'left'.
 *   valor     el valor encontrado.
 *   idx       el índice de la pestaña activa según el `left` del riel.
 *   ruta      el `pathname` en ese momento.
 *   motivo    qué disparó la revisión ('estilo-riel', 'scrollend', 'gesto',
 *             'latido', 'arranque').
 *   gesto     el último `NAV.TABSWIPE` conocido —{desde, hacia, commit}— leído
 *             del propio registro. Es la única forma de saber qué gesto precedió
 *             a la violación SIN tocar los hooks.
 *
 * Y en la consola del aparato, la misma autopsia con el prefijo `[carril][H1]`.
 *
 * ANTI-INUNDACIÓN. El latido lento revisaría la MISMA violación cada 15 s y en
 * pocos minutos se comería las 500 entradas del anillo del visor, borrando justo
 * el contexto que hace falta para leerla. Por eso se registra el CAMBIO de
 * estado: una violación nueva (o una que cambió de capa, de propiedad o de
 * valor) escribe; la misma repetida, no. Y cuando el carril vuelve a estar
 * limpio se apunta `NAV.H1` con `estado:'sano'`, para que en el registro se vea
 * dónde empezó y dónde terminó.
 */
import { IS_APP_BUILD } from '../buildTarget';
import { log as diagLog, getEntries } from './readyChainLog';
import { TAB_SLIDE_MS } from '../useTabSwipe';
import { SETTLE_GUARD_MS } from '../useEdgeSwipeBack';
import { leerCarril, marcarCarril } from '../carrilEstado';

/** Cuánto se espera tras soltar el dedo antes de juzgar el reposo. El peor caso
 *  del asentamiento del carril es `TAB_SLIDE_MS + SETTLE_GUARD_MS` (el reloj
 *  compuesto está declarado en `lib/useTabSwipe.js`); el margen es para no
 *  juzgar el frame exacto en que se suelta la transición. */
export const REPOSO_TRAS_GESTO_MS = TAB_SLIDE_MS + SETTLE_GUARD_MS + 200;

/** El latido de respaldo. Lento a propósito: los disparadores de arriba cubren
 *  los momentos interesantes, y esto sólo está para que una violación que nazca
 *  por un camino que nadie previó no se quede muda hasta el siguiente gesto. */
export const LATIDO_MS = 15000;

/** TANDA 17 (#201) — CUÁNTO VALE UNA MARCA DE `gesto`. Un dedo que sigue abajo
 *  refresca su marca en cada `touchmove`, así que sólo un estado ATORADO llega
 *  aquí; pasado el tope se plancha igual, porque una red que se puede apagar
 *  para siempre no es una red. */
export const FRESCO_GESTO_MS = 3000;

/** Y cuánto vale una marca de `settle`. El acomodo más largo del carril dura
 *  `TAB_SLIDE_MS` (290 ms); este margen lo cubre de sobra sin volverse eterno. */
export const FRESCO_SETTLE_MS = 1000;

/** TANDA 18 (#207) — CADA CUÁNTO VUELVE A PREGUNTAR EL GATILLO DEL DEDO cuando
 *  despierta sobre un acomodo fresco. No es un tope de frescura sino un
 *  re-chequeo: a los 400 ms el acomodo más largo (290 ms) ya terminó. */
export const REINTENTO_SETTLE_MS = 400;

/** Tolerancia del `left` del riel, en puntos porcentuales. React escribe
 *  enteros exactos (`idx * -100`); esto sólo absorbe el ruido de un `%` leído de
 *  vuelta como cadena con decimales. */
const TOLERANCIA_LEFT = 0.5;

function q(sel) {
  try { return document.querySelector(sel); } catch (e) { return null; }
}

function qAll(sel) {
  try { return Array.from(document.querySelectorAll(sel)); } catch (e) { return []; }
}

/** ¿Este transform es "ninguno"? Cubre las tres formas en que se puede leer:
 *  vacío (lo que deja el hook al limpiar), 'none' (lo computado) y la matriz
 *  identidad (lo computado cuando alguien escribió `translateX(0px)`). */
function sinTransform(valor) {
  const v = String(valor || '').trim();
  if (!v || v === 'none') return true;
  return v === 'matrix(1, 0, 0, 1, 0, 0)' || v === 'matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)';
}

function transformDe(nodo) {
  // El inline es lo que escribe el gesto; lo computado atrapa además cualquier
  // transform que llegara por clase. Se prefiere el inline cuando existe porque
  // dice el valor tal cual lo escribió quien lo escribió.
  try {
    const inline = nodo.style && nodo.style.transform;
    if (inline) return inline;
  } catch (e) { /* noop */ }
  try {
    return window.getComputedStyle(nodo).transform;
  } catch (e) {
    return '';
  }
}

/** El `left` del riel, en PORCENTAJE. Devuelve null si no se puede leer como
 *  porcentaje (el único formato que React escribe ahí). */
function leftPctDe(nodo) {
  let bruto = '';
  try { bruto = (nodo.style && nodo.style.left) || ''; } catch (e) { bruto = ''; }
  if (!bruto) {
    try { bruto = window.getComputedStyle(nodo).left; } catch (e) { bruto = ''; }
  }
  const m = /^(-?\d+(?:\.\d+)?)%$/.exec(String(bruto).trim());
  if (!m) return null;
  return parseFloat(m[1]);
}

function scrollLeftDe(nodo) {
  try {
    const v = nodo.scrollLeft;
    return typeof v === 'number' && isFinite(v) ? v : 0;
  } catch (e) {
    return 0;
  }
}

/** El último gesto de pestaña que el propio registro conoce. Leerlo de ahí es lo
 *  que permite fechar la violación contra un gesto SIN tocar `useTabSwipe`. */
function ultimoGesto() {
  try {
    const { entries } = getEntries();
    for (let i = entries.length - 1; i >= 0; i -= 1) {
      if (entries[i].c === 'NAV.TABSWIPE') return entries[i].d || null;
    }
  } catch (e) { /* el visor jamás decide nada */ }
  return null;
}

/** Las tres piezas del carril, o null si no hay carril montado. Una sola copia:
 *  la revisión y la cura tienen que mirar EXACTAMENTE los mismos nodos. */
function piezasDelCarril() {
  const carril = q('[data-testid="pager-carril"]');
  const gesto = q('[data-testid="pager-gesto"]');
  const riel = q('[data-testid="pager-riel"]');
  if (!carril || !gesto || !riel) return null;
  return { carril, gesto, riel };
}

/** Las capas cuyo `scrollLeft` tiene que estar en cero, EN ORDEN DE SOSPECHA
 *  (de adentro hacia afuera). Fuente única de la revisión y de la cura. */
function capasConScroll({ carril, gesto, riel }) {
  const capas = [];
  for (const pane of qAll('[data-pager-pane]')) {
    let nombre = 'pane';
    try { nombre = `pane:${pane.getAttribute('data-pager-pane') || '?'}`; } catch (e) { /* noop */ }
    capas.push([nombre, pane]);
  }
  capas.push(['riel', riel], ['gesto', gesto], ['carril', carril]);
  const main = q('main');
  if (main) capas.push(['main', main]);
  let doc = null;
  try { doc = document.scrollingElement; } catch (e) { doc = null; }
  if (doc) capas.push(['documento', doc]);
  if (document.body && document.body !== doc) capas.push(['body', document.body]);
  return capas;
}

/**
 * LA REVISIÓN, en una función pura de DOM: no escribe, no registra, sólo mira y
 * devuelve la PRIMERA violación encontrada (o null). Se exporta para las pruebas
 * y para poder llamarla a mano desde la consola del aparato.
 *
 * El orden de revisión es el de sospecha: primero los scroll horizontales de la
 * cadena (de adentro hacia afuera), después el `left` del riel y al final los
 * transforms.
 */
export function revisarH1() {
  const piezas = piezasDelCarril();
  if (!piezas) return null;   // no hay carril montado: nada que vigilar
  const { carril, gesto, riel } = piezas;

  const idxLeft = leftPctDe(riel);
  // El `|| 0` no es adorno: con `left: 0%` la división da `-0`, y un `-0` en la
  // autopsia del visor se lee como un dato raro en vez de como "la primera pestaña".
  const idx = idxLeft == null ? null : (Math.round(-idxLeft / 100) || 0);
  let ruta = '';
  try { ruta = window.location.pathname; } catch (e) { ruta = ''; }

  for (const [nombre, nodo] of capasConScroll(piezas)) {
    const sl = scrollLeftDe(nodo);
    if (sl !== 0) return { capa: nombre, prop: 'scrollLeft', valor: sl, idx, ruta };
  }

  if (idxLeft != null) {
    const resto = Math.abs(idxLeft % 100);
    if (resto > TOLERANCIA_LEFT && Math.abs(resto - 100) > TOLERANCIA_LEFT) {
      return { capa: 'riel', prop: 'left', valor: `${idxLeft}%`, idx, ruta };
    }
  }

  for (const [nombre, nodo] of [['riel', riel], ['gesto', gesto], ['carril', carril]]) {
    const tr = transformDe(nodo);
    if (!sinTransform(tr)) return { capa: nombre, prop: 'transform', valor: String(tr), idx, ruta };
  }

  return null;
}

/**
 * REMATE-266 — LA CURA. Devuelve el carril a su ley de reposo HORIZONTAL y
 * reporta qué corrigió (`[{capa, prop, de}]`); vacío = no había nada que hacer.
 *
 * Tiene DOS llamadores y por eso el interruptor del transform:
 *   · el ATERRIZAJE de pestaña (`components/PagerRaices.js`), que llama sin
 *     transform: ahí el gesto ya soltó el suyo por su propio efecto de layout y
 *     lo único que puede haber quedado sucio es un `scrollLeft`;
 *   · el TRIPWIRE al detectar, que sí lo pide — salvo desde el latido, por lo
 *     que explica el encabezado (el latido es el único que puede caer con el
 *     dedo abajo, y ahí el transform es legítimo).
 *
 * NUNCA TOCA `scrollTop`: la posición vertical de cada pane se conserva por
 * diseño. Y nunca toca una clase, una regla de CSS ni un contenedor de scroll.
 */
export function restaurarReposoHorizontal({ conTransform = false } = {}) {
  const piezas = piezasDelCarril();
  if (!piezas) return [];
  const { carril, gesto, riel } = piezas;
  const arreglados = [];

  for (const [nombre, nodo] of capasConScroll(piezas)) {
    const sl = scrollLeftDe(nodo);
    if (sl === 0) continue;
    try { nodo.scrollLeft = 0; } catch (e) { continue; }
    arreglados.push({ capa: nombre, prop: 'scrollLeft', de: sl });
  }

  /* EL `left` DEL RIEL. Un valor fraccionario significa que algo que no es React
     le está escribiendo la posición de reposo; se devuelve al múltiplo exacto de
     −100% más cercano, que es lo que React escribiría en su próximo render. No
     se inventa un índice: se redondea el que el propio riel declara, acotado al
     número de panes que hay montadas. */
  const idxLeft = leftPctDe(riel);
  if (idxLeft != null) {
    const resto = Math.abs(idxLeft % 100);
    if (resto > TOLERANCIA_LEFT && Math.abs(resto - 100) > TOLERANCIA_LEFT) {
      const panes = qAll('[data-pager-pane]').length;
      const tope = panes > 0 ? panes - 1 : 0;
      const i = Math.min(Math.max(Math.round(-idxLeft / 100) || 0, 0), tope);
      try {
        riel.style.left = `${i * -100}%`;
        arreglados.push({ capa: 'riel', prop: 'left', de: `${idxLeft}%` });
      } catch (e) { /* un nodo que no deja escribir no rompe el resto */ }
    }
  }

  if (conTransform) {
    for (const [nombre, nodo] of [['riel', riel], ['gesto', gesto], ['carril', carril]]) {
      const tr = transformDe(nodo);
      if (sinTransform(tr)) continue;
      try {
        nodo.style.transform = '';
        nodo.style.transition = '';
        arreglados.push({ capa: nombre, prop: 'transform', de: String(tr) });
      } catch (e) { /* noop */ }
    }
  }

  return arreglados;
}

/** Firma de una violación, para no registrar mil veces la misma. */
function firmaDe(v) {
  return v ? `${v.capa}|${v.prop}|${v.valor}` : 'sano';
}

/* Los tres veredictos que puede recibir un gatillo que pregunta. `CALLAR` es no
   hacer NADA: no planchar, no registrar y —lo importante— no tocar `ultimaFirma`,
   para que la próxima revisión juzgue con la vista limpia. */
const JUZGAR = 'juzgar';
const CALLAR = 'callar';
const REINTENTAR = 'reintentar';

/**
 * TANDA 17 (#201) + TANDA 18 (#207) — ¿ESTE GATILLO TIENE QUE ABSTENERSE?
 *
 * Preguntan los TRES disparadores que pueden caer sobre un carril que está
 * trabajando: el del observador del riel (~0 ms, que llega cuando React confirma
 * la pestaña, 150–300 ms después del click), el del dedo (+1310 ms) y el latido.
 * `scrollend` y el arranque no cambian ni un carácter: ocurren en momentos de
 * reposo por construcción.
 *
 * ── LO QUE LA TANDA 18 CORRIGIÓ, Y POR QUÉ ─────────────────────────────────
 * La T17 dejó al gatillo del dedo SIN frenarse ante `settle`, con este
 * argumento: "a los 1310 ms ningún acomodo legítimo sigue vivo". Es cierto para
 * UN swipe suelto y FALSO al encadenar — cada `touchend` arma su propio
 * temporizador, así que el del swipe N despierta cuando el swipe N+k lleva su
 * acomodo a media animación. El log del aparato (build 90) lo enseñó seis veces
 * en una sola ráfaga: planchazos de `translateX(416px)` —un ancho de pantalla
 * completo— sobre animaciones de 63–200 ms de vida. La edad que importa no es la
 * del temporizador sino la del ACOMODO que se está juzgando.
 *
 * Por eso ante un `settle` FRESCO el gatillo del dedo no plancha y no calla del
 * todo: se RE-AGENDA. Y la red anti-atasco no se toca, porque nadie refresca un
 * `settle` (sólo `touchmove` refresca, y eso es estado `gesto`): la marca
 * envejece sola, cruza el tope y el re-chequeo plancha. La vía al planchado del
 * rancio es INEVITABLE, venga del temporizador original o del re-agendado.
 *
 * EL LATIDO SE SUMA, PERO SÓLO PARA CALLARSE. Un acomodo sano no es una anomalía
 * y reportarlo como tal gastaba el anillo del visor mintiendo (`motivo:'latido'`
 * sobre el mismo `translateX(416px)` legítimo). Ante un estado fresco no escribe
 * y tampoco cura lo que sí curaba —el `scrollLeft` y el `left` del riel—, que es
 * lo correcto: el carril está en movimiento y esa lectura no significa nada
 * todavía. El siguiente latido, o cualquier gatillo de reposo, lo recoge.
 */
function veredictoDelGatillo(motivo) {
  let estado = 'reposo';
  let desde = 0;
  try { ({ estado, desde } = leerCarril()); } catch (e) { return JUZGAR; }
  const edad = Date.now() - desde;
  /* UNA EDAD QUE NO ES UN NÚMERO POSITIVO NO ABSTIENE A NADIE. El reloj de pared
     puede ir hacia atrás (el sistema lo ajusta, el aparato vuelve de suspensión)
     y una edad negativa cumpliría los dos topes de abajo a la vez: el curador se
     quedaría apagado hasta que el reloj alcanzara la marca —y con el re-agendado
     de la T18, aplazándose a sí mismo cada 400 ms para siempre—. La red se cae
     del lado de curar, siempre. */
  if (!(edad >= 0)) return JUZGAR;
  if (estado === 'gesto') return edad < FRESCO_GESTO_MS ? CALLAR : JUZGAR;
  if (estado === 'settle' && edad < FRESCO_SETTLE_MS) {
    return motivo === 'gesto' ? REINTENTAR : CALLAR;
  }
  return JUZGAR;
}

/**
 * arrancarCarrilTripwire() — engancha los disparadores y devuelve la función
 * para soltarlos. No-op total en web.
 *
 * Lo llama el bootstrap app-only del frontend (`contexts/AuthContext.js`), junto
 * a los demás singletons de la app.
 */
export function arrancarCarrilTripwire() {
  if (!IS_APP_BUILD) return () => {};

  let vivo = true;
  let ultimaFirma = 'sano';
  const timers = new Set();
  let sueltas = [];
  let rielEnganchado = null;

  const revisar = (motivo) => {
    if (!vivo) return;
    /* TANDA 17 (#201) — PRIMERO SE PREGUNTA, DESPUÉS SE JUZGA. Los gatillos que
       pueden caer sobre un carril que está trabajando consultan el estado antes
       de mirar un solo estilo; `scrollend` y el arranque siguen entrando derecho.

       TANDA 18 (#207) — EL LATIDO PREGUNTA, PERO NO ES UN GATILLO DEL CARRIL: se
       calla ante un estado fresco y ahí termina su papel. No plancha el
       transform (nunca lo hizo) y no declara reposo, así que se queda fuera de
       `gatilloDelCarril`, que es quien manda esa declaración. */
    const gatilloDelCarril = motivo === 'estilo-riel' || motivo === 'gesto';
    if (gatilloDelCarril || motivo === 'latido') {
      const veredicto = veredictoDelGatillo(motivo);
      /* El re-agendado es del DEDO y sólo del dedo: vuelve por el mismo camino,
         con el mismo motivo, y en el re-chequeo aplican las reglas de siempre. */
      if (veredicto === REINTENTAR) { aplazar('gesto', REINTENTO_SETTLE_MS); return; }
      if (veredicto === CALLAR) return;
    }
    let v = null;
    try { v = revisarH1(); } catch (e) { return; }   // un vigía que truena no es vigía
    const firma = firmaDe(v);
    if (firma === ultimaFirma) return;               // ya está contado
    ultimaFirma = firma;
    if (!v) {
      // Volvió a estar limpio: se apunta el final del episodio, y sólo si hubo uno.
      try { diagLog('NAV.H1', { estado: 'sano', motivo }); } catch (e) { /* noop */ }
      return;
    }
    /* REMATE-266 — SE CURA Y SE REGISTRA EL VALOR ENFERMO. La autopsia se arma
       sobre `v`, que se leyó ANTES de tocar nada, así que la línea del visor
       sigue diciendo exactamente qué se encontró y no el estado ya corregido.
       `curado` lista lo que se pudo devolver a su ley; vacío significa "se
       detectó y no se corrigió" —el caso del latido con el transform—, y esa
       diferencia también se lee en el registro. */
    const conTransform = motivo !== 'latido';
    let curado = [];
    try { curado = restaurarReposoHorizontal({ conTransform }); } catch (e) { curado = []; }
    /* Y PLANCHAR ES UNA LIMPIEZA DE PLENO DERECHO, así que se declara — igual
       que la del hook. Sólo desde los dos gatillos del carril: desde el latido
       sería mentira (ahí el transform no se cura) y desde los otros dos no hay
       nada que declarar que no supiera ya quien los provocó. */
    if (gatilloDelCarril) marcarCarril('reposo');
    const autopsia = { ...v, motivo, gesto: ultimoGesto(), curado };
    try { diagLog('NAV.H1', autopsia); } catch (e) { /* noop */ }
    try {
      // eslint-disable-next-line no-console
      console.warn('[carril][H1]', autopsia);
    } catch (e) { /* una bitácora jamás rompe una pantalla */ }
    /* Y la firma se recalcula contra el estado REAL de después de curar. Si la
       cura funcionó, el carril ya está sano y la firma vuelve a 'sano' sin
       gastar una línea extra —el cierre del episodio ya lo dice `curado` en la
       misma entrada—. Si quedó algo (una violación distinta, o el transform que
       el latido no cura), la firma es la de ESO, y la próxima revisión la
       apuntará como lo que es: una violación nueva. */
    if (curado.length > 0) {
      try { ultimaFirma = firmaDe(revisarH1()); } catch (e) { /* noop */ }
    }
  };

  /* TANDA 18 (#207) — UN SOLO TEMPORIZADOR DEL DEDO A LA VEZ. Cada `touchend`
     armaba el suyo y `aplazar` los APILABA, así que una ráfaga de swipes dejaba
     media docena de revisiones viejas cayendo sobre acomodos recién nacidos. El
     que vale es siempre el ÚLTIMO: se juzga 1310 ms después de que el dedo dejó
     de trabajar, no de cuando empezó. El re-agendado entra por aquí mismo, así
     que tampoco puede acumular dos cadenas en paralelo.
     Los otros motivos se quedan como estaban: `estilo-riel` y `arranque` van a
     0 ms (nada que colapsar) y el latido no pasa por aquí. */
  let timerDelDedo = null;
  const aplazar = (motivo, ms) => {
    if (!vivo) return;
    if (motivo === 'gesto' && timerDelDedo != null) {
      try { clearTimeout(timerDelDedo); } catch (e) { /* noop */ }
      timers.delete(timerDelDedo);
      timerDelDedo = null;
    }
    const id = setTimeout(() => {
      timers.delete(id);
      // Se suelta ANTES de revisar: si la revisión decide re-agendarse, el que
      // guarda el hueco tiene que ser el nuevo, no el que acaba de disparar.
      if (timerDelDedo === id) timerDelDedo = null;
      revisar(motivo);
    }, ms);
    timers.add(id);
    if (motivo === 'gesto') timerDelDedo = id;
  };

  const soltarDisparadores = () => {
    for (const soltar of sueltas) soltar();
    sueltas = [];
    rielEnganchado = null;
  };

  /* EL ENGANCHE. El carril NO está en el DOM cuando arranca el bootstrap (se
     monta con la ruta), así que esto es reintentable: se llama al arrancar y
     desde el latido, y sólo hace trabajo cuando el nodo del riel cambió — el
     caso del primer montaje y el de un remontaje. */
  const engancharDisparadores = () => {
    const riel = q('[data-testid="pager-riel"]');
    if (riel === rielEnganchado) return;
    soltarDisparadores();
    if (!riel) return;
    rielEnganchado = riel;

    // (a) EL CAMBIO DE PESTAÑA, gratis: React escribe el `left` del riel y nada
    //     más lo toca. El gesto pinta el NODO DEL GESTO, así que arrastrar no
    //     dispara esto ni una vez.
    try {
      if (typeof window.MutationObserver === 'function') {
        const mo = new window.MutationObserver(() => aplazar('estilo-riel', 0));
        mo.observe(riel, { attributes: true, attributeFilter: ['style'] });
        sueltas.push(() => { try { mo.disconnect(); } catch (e) { /* noop */ } });
      }
    } catch (e) { /* sin observador quedan los otros tres disparadores */ }

    // (b) EL ATERRIZAJE DE UN SCROLL. `scrollend` es exactamente el instante en
    //     que un desplazamiento rebelde se queda quieto. Donde el navegador no
    //     lo soporte, este disparador simplemente no existe.
    let conScrollend = false;
    try { conScrollend = typeof window !== 'undefined' && 'onscrollend' in window; } catch (e) { conScrollend = false; }
    if (conScrollend) {
      const alTerminarScroll = () => revisar('scrollend');
      const nodos = [...qAll('[data-pager-pane]'), q('[data-testid="pager-carril"]'), q('main')].filter(Boolean);
      for (const n of nodos) {
        try {
          n.addEventListener('scrollend', alTerminarScroll, { passive: true });
          sueltas.push(() => { try { n.removeEventListener('scrollend', alTerminarScroll); } catch (e) { /* noop */ } });
        } catch (e) { /* noop */ }
      }
    }

    // (c) EL DEDO SE LEVANTÓ. Pasivo y SÓLO al soltar —jamás `touchmove`—, y la
    //     revisión se aplaza hasta después del peor asentamiento posible: antes
    //     de eso el carril tiene transform legítimamente y juzgarlo sería mentir.
    const carril = q('[data-testid="pager-carril"]');
    if (carril) {
      const alSoltar = () => aplazar('gesto', REPOSO_TRAS_GESTO_MS);
      for (const ev of ['touchend', 'touchcancel']) {
        try {
          carril.addEventListener(ev, alSoltar, { passive: true });
          sueltas.push(() => { try { carril.removeEventListener(ev, alSoltar); } catch (e) { /* noop */ } });
        } catch (e) { /* noop */ }
      }
    }
  };

  // (d) EL LATIDO DE RESPALDO, que además es quien reintenta el enganche.
  let intervalo = null;
  try {
    intervalo = setInterval(() => { engancharDisparadores(); revisar('latido'); }, LATIDO_MS);
  } catch (e) { intervalo = null; }

  engancharDisparadores();
  // Y una lectura de arranque, para que el registro tenga línea base.
  aplazar('arranque', 0);

  return () => {
    vivo = false;
    if (intervalo) { try { clearInterval(intervalo); } catch (e) { /* noop */ } }
    for (const id of timers) { try { clearTimeout(id); } catch (e) { /* noop */ } }
    timers.clear();
    soltarDisparadores();
  };
}
